export default __webpack_public_path__ + "static/AzoSansItalic-5abf33a0d4754b94ab8d57891456dbc3.woff";